import { Routes } from '@angular/router';
import { CommunitiesDetailsRoute } from '../../enums';

export const COMMUNITY_DETAILS_PAGE_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('./details.component').then((m) => m.DetailsPageComponent),
        children: [
            {
                path: CommunitiesDetailsRoute.Statistics,
                loadComponent: () => import('./statistics').then((m) => m.StatisticsTabComponent)
            },
            {
                path: CommunitiesDetailsRoute.Settings,
                loadComponent: () => import('./settings').then((m) => m.SettingsTabComponent)
            },
            {
                path: CommunitiesDetailsRoute.History,
                loadComponent: () => import('./history').then((m) => m.HistoryTabComponent)
            },
            {
                path: '**',
                redirectTo: CommunitiesDetailsRoute.Settings
            }
        ]
    }
];
